import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=00ad4a0a"
var script = {}
import style0 from "./Media.vue?vue&type=style&index=0&id=00ad4a0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports